import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps, branch, renderNothing } from 'recompose';
import { isInteger } from 'lodash';

import './RatingBar.scss';

export const enhance = compose(
	withProps(({ rating }) => ({
		percent: (parseInt(rating) / 5) * 100,
		rating: parseInt(rating),
	})),
	branch(({ rating }) => !isInteger(rating), renderNothing),
);

export function RatingBar({ name, rating, percent, outOf }) {
	return (
		<div className="rating-bar">
			<div
				className="progress-bar"
				style={{
					width: `${percent}%`,
				}}
			/>
			<div className="rating-text">
				{name} - {rating}/{outOf}
			</div>
		</div>
	);
}

RatingBar.propTypes = {
	name: PropTypes.string.isRequired,
	rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
		.isRequired,
	outOf: PropTypes.number.isRequired,
	percent: PropTypes.number,
};

export default enhance(RatingBar);
